import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faKey, faRoad, faTimes, faGripLines, faRandom, faChevronLeft, faChevronRight, faRoute, faMapMarkedAlt,
  faPlus, faMinus, faFlagCheckered, faAngleDoubleRight, faScannerTouchscreen, faPrint, faCheck, faLink as farLink, faPaperPlane, faPencilAlt, faClipboard
} from '@fortawesome/pro-regular-svg-icons'

import {
  faBars, faSignOut, faTachometerAlt, faUsers, faBuilding, faBriefcase, faSuitcase, faBarcode, faWrench, faTruck,
  faBook, faExclamation, faUser, faLink, faCaretDown, faList, faRoad as fasRoad, faCogs, faUndo, faPlane, faTrash
} from '@fortawesome/pro-solid-svg-icons'

import {
  faCircleNotch
} from '@fortawesome/pro-light-svg-icons'

import {
  faShirtsinbulk
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faTachometerAlt, faUsers, faShirtsinbulk, faBuilding, faBriefcase, faSuitcase, faBarcode, faWrench, faTruck, faLink, faBook,
  faBars, faExclamation, faSignOut, faKey, faUser, faCaretDown, faRoad, faTimes, faCircleNotch, faGripLines, faTrash,
  faRandom, faChevronLeft, faChevronRight, faRoute, faMapMarkedAlt, faPlus, faMinus, faFlagCheckered, faList, fasRoad, faCogs,
  faAngleDoubleRight, faScannerTouchscreen, faPrint, faCheck, faUndo, farLink, faPlane, faPaperPlane, faPencilAlt, faClipboard
)

Vue.component('font-awesome', FontAwesomeIcon)
